import React from 'react';
import "./ManagerToast.scss";

import { ReactComponent as SuccessIcon } from "static/icons/check-circle.svg";
import { ReactComponent as ErrorIcon } from "static/icons/cross-circle.svg";

const ManagerToast = ({isSuccess, text}) => {
  return (
    <div className="manager-toast">
      {
        isSuccess ?
        <div className="manager-toast__icon-container-success">
          <SuccessIcon className="manager-toast__icon-error-success" />
        </div> :
        <div className="manager-toast__icon-container-error">
          <ErrorIcon className="manager-toast__icon-error" />
        </div>
      }
      <div className="manager-toast__text">
        {text}
      </div>
    </div>
  );
};

export default ManagerToast;
